interface Util {
  title: any;
}

const util: Util = {
  title: function(title: string) {
    title = title ? title + " - 格隆汇" : "格隆汇券商席位查询系统";
    window.document.title = title;
  }
};
export default util;
